export const LevelEffects = ({ currentLevel, gameState, frame }) => {
  if (gameState !== 'playing') return null;

  return (
    <>
      {/* Sky Level - Birds */}
      {currentLevel === 0 && (
        <>
          <div className="absolute text-2xl" style={{ left: `${(frame * 0.6) % 500}px`, top: `${80 + Math.sin(frame * 0.05) * 30}px`, transform: 'scaleX(-1)', transition: 'top 0.1s ease-out' }}>
            {frame % 20 < 10 ? '🕊️' : '🐦'}
          </div>
          <div className="absolute text-xl" style={{ left: `${(frame * 0.4 + 150) % 500}px`, top: `${60 + Math.sin(frame * 0.03) * 20}px`, transform: 'scaleX(-1)', transition: 'top 0.15s ease-out' }}>
            {frame % 30 < 15 ? '🦅' : '🦜'}
          </div>
          <div className="absolute text-lg" style={{ left: `${(frame * 0.7 + 250) % 500}px`, top: `${150 + Math.sin(frame * 0.08) * 25}px`, transform: 'scaleX(-1)', transition: 'top 0.08s ease-out' }}>
            {frame % 15 < 8 ? '🐦' : '🕊️'}
          </div>
        </>
      )}

      {/* Desert Level - Vultures */}
      {currentLevel === 1 && (
        <>
          <div className="absolute text-2xl" style={{ left: `${(frame * 0.3) % 450}px`, top: `${100 + Math.sin(frame * 0.04) * 40}px`, transform: frame % 100 < 50 ? 'scaleX(-1)' : 'scaleX(1)', transition: 'all 0.2s ease-out' }}>
            {frame % 35 < 18 ? '🦅' : '🦇'}
          </div>
          <div className="absolute text-xl" style={{ left: `${(frame * 0.65 + 100) % 500}px`, top: `${70 + Math.sin(frame * 0.06) * 20}px`, transform: 'scaleX(-1) rotate(-5deg)', transition: 'top 0.1s ease-out' }}>
            {frame % 20 < 10 ? '🦅' : '🪶'}
          </div>
          <div className="absolute text-lg" style={{ left: `${(frame * 0.45 + 200) % 480}px`, top: `${180 + Math.cos(frame * 0.035) * 30}px`, transform: 'scaleX(-1)', transition: 'top 0.15s ease-out' }}>
            {frame % 40 < 20 ? '🦜' : '🐦'}
          </div>
        </>
      )}

      {/* Jungle Level - Monkeys + Birds */}
      {currentLevel === 2 && (
        <>
          <div className="absolute text-2xl" style={{ left: '30px', top: `${100 + Math.sin(frame * 0.02) * 200}px`, transition: 'top 0.2s ease-out' }}>
            {Math.sin(frame * 0.02) > 0 ? '🐒' : '🐵'}
          </div>
          <div className="absolute text-xl" style={{ right: '40px', top: `${150 + Math.cos(frame * 0.025) * 180}px`, transition: 'top 0.2s ease-out' }}>
            {Math.cos(frame * 0.025) < 0 ? '🐵' : '🦧'}
          </div>
          <div className="absolute text-lg" style={{ left: '350px', top: `${80 + Math.sin(frame * 0.035) * 220}px`, transition: 'top 0.15s ease-out' }}>
            {frame % 30 < 15 ? '🐒' : '🙈'}
          </div>
          <div className="absolute text-xl" style={{ left: `${(frame * 0.5) % 480}px`, top: `${90 + Math.sin(frame * 0.06) * 25}px`, transform: 'scaleX(-1)', transition: 'top 0.1s ease-out' }}>
            {frame % 25 < 13 ? '🦜' : '🦩'}
          </div>
          <div className="absolute text-lg" style={{ left: `${(frame * 0.35 + 200) % 450}px`, top: `${170 + Math.cos(frame * 0.045) * 30}px`, transform: 'scaleX(-1)', transition: 'top 0.12s ease-out' }}>
            {frame % 20 < 10 ? '🦜' : '🐦'}
          </div>
        </>
      )}

      {/* London Level - Pigeons */}
      {currentLevel === 3 && (
        <>
          <div className="absolute text-xl" style={{ left: `${(frame * 0.5) % 480}px`, top: `${100 + Math.sin(frame * 0.05) * 20}px`, transform: 'scaleX(-1)', transition: 'top 0.1s ease-out' }}>
            {frame % 18 < 9 ? '🐦' : '🕊️'}
          </div>
          <div className="absolute text-lg" style={{ left: `${(frame * 0.65 + 100) % 500}px`, top: `${150 + Math.sin(frame * 0.07) * 30}px`, transform: 'scaleX(-1)', transition: 'top 0.08s ease-out' }}>
            {frame % 22 < 11 ? '🕊️' : '🐦'}
          </div>
          <div className="absolute text-2xl" style={{ left: `${(frame * 0.4 + 250) % 460}px`, top: `${70 + Math.cos(frame * 0.035) * 25}px`, transform: 'scaleX(-1)', transition: 'top 0.13s ease-out' }}>
            {frame % 30 < 15 ? '🐦‍⬛' : '🦅'}
          </div>
        </>
      )}

      {/* Mountain Level - Eagles, Snow, Wind */}
      {currentLevel === 4 && (
        <>
          <div className="absolute text-2xl" style={{ left: `${(frame * 0.35) % 480}px`, top: `${50 + Math.sin(frame * 0.025) * 35}px`, transform: 'scaleX(-1)', transition: 'top 0.15s ease-out' }}>
            {frame % 40 < 20 ? '🦅' : '🪶'}
          </div>
          <div className="absolute text-xl" style={{ left: `${(frame * 0.5 + 200) % 500}px`, top: `${130 + Math.cos(frame * 0.04) * 25}px`, transform: 'scaleX(-1) rotate(-3deg)', transition: 'top 0.12s ease-out' }}>
            {frame % 30 < 15 ? '🦅' : '🐦'}
          </div>
          {[...Array(6)].map((_, i) => (
            <div key={`snow-${i}`} className="absolute text-sm pointer-events-none"
              style={{ left: `${(frame * (0.2 + i * 0.12) + i * 70) % 420}px`, top: `${(frame * (0.4 + i * 0.08) + i * 90) % 620}px`, opacity: 0.6 }}>
              ❄
            </div>
          ))}
          {[...Array(3)].map((_, i) => (
            <div key={`wind-${i}`} className="absolute pointer-events-none"
              style={{ left: `${(frame * 1.5 + i * 150) % 500 - 50}px`, top: `${100 + i * 170}px`, width: '60px', height: '2px',
                background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)',
                opacity: Math.sin(frame * 0.05 + i) > 0 ? 0.5 : 0 }} />
          ))}
        </>
      )}

      {/* Space Level - Stars, Asteroids, Satellite */}
      {currentLevel === 5 && (
        <>
          {[...Array(10)].map((_, i) => (
            <div key={`star-${i}`} className="absolute pointer-events-none"
              style={{ left: `${(i * 43 + 10) % 400}px`, top: `${(i * 67 + 20) % 580}px`, width: '3px', height: '3px', borderRadius: '50%', background: '#fff',
                opacity: Math.sin(frame * 0.08 + i * 1.3) > 0.3 ? 0.9 : 0.15, boxShadow: '0 0 4px 1px rgba(255,255,255,0.6)' }} />
          ))}
          <div className="absolute text-xl pointer-events-none"
            style={{ left: `${(frame * 0.6 + 50) % 500}px`, top: `${200 + Math.sin(frame * 0.03) * 60}px`, transform: `rotate(${frame * 2}deg)`, opacity: 0.7 }}>
            ☄
          </div>
          <div className="absolute text-sm pointer-events-none"
            style={{ left: `${(frame * 0.9 + 250) % 480}px`, top: `${350 + Math.cos(frame * 0.04) * 40}px`, transform: `rotate(${-frame * 3}deg)`, opacity: 0.5 }}>
            🪨
          </div>
          <div className="absolute text-lg pointer-events-none"
            style={{ left: `${(frame * 0.25 + 100) % 450}px`, top: `${60 + Math.sin(frame * 0.015) * 20}px`, opacity: 0.6 }}>
            🛰
          </div>
          <div className="absolute pointer-events-none rounded-full"
            style={{ right: '20px', top: '40px', width: '35px', height: '35px',
              background: 'radial-gradient(circle, rgba(147,51,234,0.4) 0%, transparent 70%)',
              boxShadow: '0 0 20px rgba(147,51,234,0.3)', opacity: 0.6 + Math.sin(frame * 0.02) * 0.3 }} />
        </>
      )}

      {/* Volcano Level - Fire, Embers, Ash, Lava */}
      {currentLevel === 6 && (
        <>
          {[...Array(8)].map((_, i) => (
            <div key={`ember-${i}`} className="absolute pointer-events-none"
              style={{ left: `${(i * 55 + frame * 0.3) % 420}px`, bottom: `${(frame * (0.5 + i * 0.15) + i * 80) % 650}px`,
                width: `${4 + Math.random() * 3}px`, height: `${4 + Math.random() * 3}px`, borderRadius: '50%',
                background: i % 3 === 0 ? '#ff4500' : i % 3 === 1 ? '#ff6b00' : '#ffaa00',
                opacity: Math.sin(frame * 0.1 + i) > -0.3 ? 0.7 : 0.2,
                boxShadow: `0 0 6px ${i % 2 === 0 ? '#ff4500' : '#ff8c00'}` }} />
          ))}
          <div className="absolute text-2xl pointer-events-none"
            style={{ left: `${80 + Math.sin(frame * 0.04) * 50}px`, bottom: `${10 + Math.abs(Math.sin(frame * 0.06)) * 40}px`, opacity: 0.6 }}>
            🔥
          </div>
          <div className="absolute text-xl pointer-events-none"
            style={{ left: `${280 + Math.cos(frame * 0.035) * 40}px`, bottom: `${5 + Math.abs(Math.sin(frame * 0.07 + 1)) * 35}px`, opacity: 0.5 }}>
            🔥
          </div>
          {[...Array(4)].map((_, i) => (
            <div key={`ash-${i}`} className="absolute pointer-events-none"
              style={{ left: `${(frame * 0.4 + i * 110) % 430}px`, top: `${(frame * 0.3 + i * 150) % 600}px`,
                width: '8px', height: '8px', borderRadius: '50%', background: 'rgba(80,80,80,0.4)', filter: 'blur(2px)' }} />
          ))}
          <div className="absolute bottom-0 left-0 right-0 h-12 pointer-events-none"
            style={{ background: 'linear-gradient(0deg, rgba(255,69,0,0.4) 0%, transparent 100%)', opacity: 0.5 + Math.sin(frame * 0.05) * 0.3 }} />
        </>
      )}
    </>
  );
};
